module.exports = __webpack_public_path__ + "img/descalvado.f5c8c481.png";